import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export function Newsletter() {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!consent) { toast.error("Bitte stimmen Sie der Datenschutzerklärung zu."); return; }
    setLoading(true);
    try { const { data } = await api.post("/newsletter/subscribe", { email, gdpr_consent: consent }); toast.success(data.message); setEmail(""); setConsent(false); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <section className="bg-navy-800 border-y border-white/5" data-testid="newsletter">
      <div className="max-w-4xl mx-auto px-6 py-14 text-center">
        <Mail className="text-gold-500 mx-auto" size={28} />
        <h2 className="mt-4 text-2xl sm:text-3xl font-bold text-white tracking-tight">Bleiben Sie informiert</h2>
        <p className="mt-2 text-slate-400">Tipps zu Versicherung, Finanzierung & Immobilien – direkt in Ihr Postfach.</p>
        <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="newsletter-form">
          <input data-testid="newsletter-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Ihre E-Mail-Adresse"
            className="flex-1 bg-navy-900 border border-white/10 text-white rounded-sm px-4 py-3 text-sm placeholder:text-slate-500 focus:ring-1 focus:ring-gold-500 focus:border-gold-500 focus:outline-none" />
          <button data-testid="newsletter-submit" disabled={loading} className="bg-gold-500 text-navy-900 font-bold rounded-sm px-6 py-3 text-sm hover:bg-gold-300 transition-colors disabled:opacity-60">{loading ? "…" : "Abonnieren"}</button>
        </form>
        <label className="mt-3 flex items-center justify-center gap-2 text-xs text-slate-500 cursor-pointer">
          <input data-testid="newsletter-consent" type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="accent-gold-500 w-4 h-4" />
          Ich stimme der Datenschutzerklärung zu und kann mich jederzeit abmelden.
        </label>
      </div>
    </section>
  );
}
